import React from "react";

export default function IconSprite() {
  // Style commun (hérité par les paths / rect / circle)
  const common = {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: "none" }}
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        {/* ========== Confort & rangement ========== */}
        <symbol id="i-linge" viewBox="0 0 24 24" {...common}>
          <path d="M3 14V9a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v5" />
          <path d="M3 14h18v4H3z" />
          <path d="M7 10h4" />
          <path d="M14.5 13.5l3-3 2 2-3 3h-2z" />
        </symbol>

        <symbol id="i-dressing" viewBox="0 0 24 24" {...common}>
          <path d="M12 6c2.5 0 4-1.2 4-3H8c0 1.8 1.5 3 4 3Z" />
          <path d="M12 6v3" />
          <path d="M4 10l8-1 8 1" />
          <path d="M6 10c0 6 3 10 6 10s6-4 6-10" />
        </symbol>

        <symbol id="i-ventilateur" viewBox="0 0 24 24" {...common}>
          <circle cx="12" cy="10" r="2" />
          <path d="M12 3c3 0 3 3 1.5 4.5S10 9 8 8.5 6 5 9 4" />
          <path d="M21 10c0 3-3 3-4.5 1.5S15 8 15.5 6 19 4 20 7" />
          <path d="M12 19c-3 0-3-3-1.5-4.5S14 13 16 13.5 18 17 15 18" />
          <path d="M12 12v9" />
          <path d="M9 21h6" />
        </symbol>

        <symbol id="i-chauffage" viewBox="0 0 24 24" {...common}>
          <rect x="5" y="7" width="14" height="12" rx="2" />
          <path d="M8 10v6M11 10v6M14 10v6M17 10v6" />
          <path d="M8 5c0-1 1-2 2-2M12 5c0-1 1-2 2-2M16 5c0-1 1-2 2-2" />
        </symbol>

        {/* ========== Cuisine & électroménager ========== */}
        <symbol id="i-plaque-cuisson" viewBox="0 0 24 24" {...common}>
          <rect x="4" y="6" width="16" height="12" rx="2" />
          <circle cx="9" cy="10" r="2" />
          <circle cx="15" cy="14" r="2" />
        </symbol>

        <symbol id="i-four" viewBox="0 0 24 24" {...common}>
          <rect x="5" y="4" width="14" height="16" rx="2" />
          <path d="M7 8h10" />
          <rect x="8" y="11" width="8" height="6" rx="1" />
          <circle cx="9" cy="6" r="1" />
          <circle cx="12" cy="6" r="1" />
          <circle cx="15" cy="6" r="1" />
        </symbol>

        <symbol id="i-micro-ondes" viewBox="0 0 24 24" {...common}>
          <rect x="4" y="7" width="16" height="10" rx="2" />
          <rect x="6.5" y="9" width="9" height="6" rx="1" />
          <path d="M17.5 10h1M17.5 12h1M17.5 14h1" />
          <path d="M8 12c1-1 2-1 3 0s2 1 3 0" />
        </symbol>

        <symbol id="i-refrigerateur" viewBox="0 0 24 24" {...common}>
          <rect x="7" y="3" width="10" height="18" rx="2" />
          <path d="M7 11h10" />
          <path d="M15 6v2M15 14v2" />
        </symbol>

        <symbol id="i-congelateur" viewBox="0 0 24 24" {...common}>
          <rect x="6" y="4" width="12" height="16" rx="2" />
          <path d="M12 7v10M8.5 9l7 6M15.5 9l-7 6" />
        </symbol>

        <symbol id="i-grille-pain" viewBox="0 0 24 24" {...common}>
          <rect x="6" y="9" width="12" height="10" rx="2" />
          <path d="M8 9V7a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
          <path d="M9 13h6" />
          <path d="M18 12h1v4" />
        </symbol>

        <symbol id="i-cafetiere" viewBox="0 0 24 24" {...common}>
          <rect x="6" y="4" width="12" height="6" rx="2" />
          <path d="M8 10v7h8v-7" />
          <path d="M9 20h6" />
          <path d="M11 12v2" />
          <path d="M7 17c1 2 9 2 10 0" />
        </symbol>

        <symbol id="i-bouilloire" viewBox="0 0 24 24" {...common}>
          <path d="M7 10a5 5 0 0 1 10 0v6H7v-6Z" />
          <path d="M17 11h1a2 2 0 0 1 0 4h-1" />
          <path d="M10 7l2-2 2 2" />
          <path d="M9 20h6" />
        </symbol>

        <symbol id="i-blender" viewBox="0 0 24 24" {...common}>
          <path d="M9 4h6l-1 6H10L9 4Z" />
          <path d="M10 10v6a2 2 0 0 0 2 2h0a2 2 0 0 0 2-2v-6" />
          <rect x="8" y="18" width="8" height="3" rx="1.5" />
          <path d="M12 13l1 1-1 1-1-1 1-1Z" />
        </symbol>

        <symbol id="i-lave-vaisselle" viewBox="0 0 24 24" {...common}>
          <rect x="6" y="4" width="12" height="16" rx="2" />
          <path d="M8 8h8" />
          <circle cx="10" cy="14" r="2.5" />
          <path d="M14.5 12.5c1.5 1.5 1.5 3.5 0 5" />
        </symbol>

        <symbol id="i-vaisselle-couverts" viewBox="0 0 24 24" {...common}>
          <circle cx="9" cy="12" r="5" />
          <path d="M16 7v10M18 7v10" />
          <path d="M16 12h2" />
        </symbol>

        <symbol id="i-ustensiles-cuisine" viewBox="0 0 24 24" {...common}>
          <path d="M7 4v9" />
          <path d="M5 4v4a2 2 0 0 0 4 0V4" />
          <path d="M7 13v7" />
          <path d="M15 4v7a3 3 0 0 0 3 3v6" />
          <path d="M13 7h4" />
        </symbol>

        {/* ========== Salle de bain & entretien ========== */}
        <symbol id="i-douche-italienne" viewBox="0 0 24 24" {...common}>
          <path d="M7 5h6a4 4 0 0 1 4 4v2" />
          <path d="M17 11l-6 0" />
          <path d="M12 13v0M9 14v0M15 14v0M10.5 16v0M13.5 16v0" />
          <path d="M4 20h16" />
        </symbol>

        <symbol id="i-baignoire" viewBox="0 0 24 24" {...common}>
          <path d="M6 12V7a2 2 0 0 1 2-2h2" />
          <path d="M5 12h14v2a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4v-2Z" />
          <path d="M8 18v2M16 18v2" />
          <path d="M10 5h3" />
        </symbol>

        <symbol id="i-shampooing" viewBox="0 0 24 24" {...common}>
          <rect x="9" y="3" width="6" height="3" rx="1" />
          <rect x="8" y="6" width="8" height="15" rx="2" />
          <path d="M10 10h4" />
        </symbol>

        <symbol id="i-gel-douche" viewBox="0 0 24 24" {...common}>
          <path d="M10 4h6" />
          <path d="M14 4v2" />
          <rect x="8" y="6" width="8" height="15" rx="2" />
          <path d="M10 12h4" />
        </symbol>

        <symbol id="i-serviettes-gants" viewBox="0 0 24 24" {...common}>
          <path d="M6 6h8v12H6z" />
          <path d="M9 6v12" />
          <path d="M16 12c0-1.5 1-2.5 2-2.5 1 0 1.2.8 1.2 1.6V16c0 2-1.2 3-3.2 3H16" />
        </symbol>

        <symbol id="i-seche-cheveux" viewBox="0 0 24 24" {...common}>
          <path d="M5 12h10a3 3 0 0 0 0-6H7a2 2 0 0 0-2 2v4Z" />
          <path d="M15 10h4v4h-4" />
          <path d="M9 12v6h3" />
          <path d="M19 12c1 0 2 .5 2 2" />
        </symbol>

        <symbol id="i-lave-linge" viewBox="0 0 24 24" {...common}>
          <rect x="6" y="4" width="12" height="16" rx="2" />
          <circle cx="12" cy="13" r="4" />
          <path d="M8 7h2M12 7h4" />
        </symbol>

        <symbol id="i-fer-repasser" viewBox="0 0 24 24" {...common}>
          <path d="M5 14h12l2 3H7l-2-3Z" />
          <path d="M10 14c0-3 2-5 6-5v5" />
          <path d="M6 20h14" />
          <path d="M9 17l-1 3M15 17l1 3" />
        </symbol>

        <symbol id="i-etendoire" viewBox="0 0 24 24" {...common}>
          <path d="M6 8h12" />
          <path d="M7 8l-2 12M17 8l2 12" />
          <path d="M8 12h8M8.5 15h7M9 18h6" />
        </symbol>

        <symbol id="i-produits-nettoyage" viewBox="0 0 24 24" {...common}>
          <path d="M9 6h6l1 2H8l1-2Z" />
          <rect x="8" y="8" width="8" height="13" rx="2" />
          <path d="M14 4h3v2" />
          <path d="M10 12h4" />
        </symbol>

        <symbol id="i-ustensiles-nettoyage" viewBox="0 0 24 24" {...common}>
          <path d="M6 4l6 6" />
          <path d="M10 8l-5 12" />
          <path d="M14 10h6l-1 11h-4l-1-11Z" />
          <path d="M14 13h6" />
        </symbol>

        {/* ========== Wi-Fi & loisirs ========== */}
        <symbol id="i-wifi-fibre" viewBox="0 0 24 24" {...common}>
          <path d="M5 10a11 11 0 0 1 14 0" />
          <path d="M8 13a7 7 0 0 1 8 0" />
          <path d="M11 16a3 3 0 0 1 2 0" />
          <circle cx="12" cy="19" r="1" />
        </symbol>

        <symbol id="i-television" viewBox="0 0 24 24" {...common}>
          <rect x="4" y="6" width="16" height="11" rx="2" />
          <path d="M8 20h8" />
          <path d="M12 17v3" />
        </symbol>

        <symbol id="i-tennis-table" viewBox="0 0 24 24" {...common}>
          <rect x="5" y="7" width="14" height="8" rx="1" />
          <path d="M12 7v8" />
          <path d="M8 15l-2 5M16 15l2 5" />
          <circle cx="18.5" cy="9.5" r="1" />
        </symbol>

        <symbol id="i-petanque" viewBox="0 0 24 24" {...common}>
          <circle cx="8" cy="14" r="3" />
          <circle cx="15.5" cy="15.5" r="2.5" />
          <circle cx="17.5" cy="9" r="1" />
          <path d="M7 14h2M14.5 15.5h2" />
        </symbol>

        <symbol id="i-molkky" viewBox="0 0 24 24" {...common}>
          <path d="M6 18l2-8h2l-2 8H6Z" />
          <path d="M11 18l2-10h2l-2 10h-2Z" />
          <path d="M16 18l2-7h2l-2 7h-2Z" />
          <path d="M5 20h14" />
        </symbol>

        <symbol id="i-salle-jeux" viewBox="0 0 24 24" {...common}>
          <path d="M7 14l-1 5a2 2 0 0 0 2 2h1l2-2h2l2 2h1a2 2 0 0 0 2-2l-1-5a4 4 0 0 0-4-3H11a4 4 0 0 0-4 3Z" />
          <path d="M10 14h-3M8.5 12.5v3" />
          <path d="M16 13h0M18 15h0" />
          <circle cx="16" cy="13" r="0.5" />
          <circle cx="18" cy="15" r="0.5" />
        </symbol>

        <symbol id="i-jeux-societe" viewBox="0 0 24 24" {...common}>
          <rect x="6" y="6" width="12" height="12" rx="2" />
          <circle cx="10" cy="10" r="1" />
          <circle cx="14" cy="14" r="1" />
          <circle cx="14" cy="10" r="1" />
          <circle cx="10" cy="14" r="1" />
        </symbol>

        <symbol id="i-jeu-flechette" viewBox="0 0 24 24" {...common}>
          <circle cx="12" cy="12" r="7" />
          <circle cx="12" cy="12" r="3" />
          <path d="M14 6l5-2-2 5" />
          <path d="M15 7l-3 3" />
        </symbol>

        <symbol id="i-livres" viewBox="0 0 24 24" {...common}>
          <path d="M7 5h10v14H7a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z" />
          <path d="M9 7h6" />
          <path d="M17 19H7a2 2 0 0 0-2 2h12" />
        </symbol>

        {/* ========== Extérieur ========== */}
        <symbol id="i-piscine-privative" viewBox="0 0 24 24" {...common}>
          <path d="M7 4v12M17 4v12" />
          <path d="M7 6h10M7 10h10M7 14h10" />
          <path d="M4 20c2-2 4-2 6 0s4 2 6 0 4-2 6 0" />
        </symbol>

        <symbol id="i-douche-piscine" viewBox="0 0 24 24" {...common}>
          <path d="M8 4h6a4 4 0 0 1 4 4v2" />
          <path d="M18 10h-6" />
          <path d="M13 12v0M10 13v0M16 13v0M12 15v0M14 15v0" />
          <path d="M4 20c2-2 4-2 6 0s4 2 6 0 4-2 6 0" />
        </symbol>

        <symbol id="i-serviettes-piscine" viewBox="0 0 24 24" {...common}>
          <path d="M7 6h8v11H7z" />
          <path d="M10 6v11" />
          <path d="M4 20c2-2 4-2 6 0s4 2 6 0 4-2 6 0" />
        </symbol>

        <symbol id="i-transats" viewBox="0 0 24 24" {...common}>
          <path d="M6 16l10-8 2 2-10 8H6Z" />
          <path d="M6 16l-2 4" />
          <path d="M18 10l2 4" />
          <path d="M10 18h8" />
        </symbol>

        <symbol id="i-parasol" viewBox="0 0 24 24" {...common}>
          <path d="M12 4c5 0 8 3 8 6H4c0-3 3-6 8-6Z" />
          <path d="M12 10v10" />
          <path d="M12 20c0 2 2 2 3 1" />
          <path d="M8 10c0-2 1-3 4-3s4 1 4 3" />
        </symbol>

        <symbol id="i-arriere-cour" viewBox="0 0 24 24" {...common}>
          <path d="M4 11l8-6 8 6v9H4v-9Z" />
          <path d="M10 20v-6h4v6" />
          <path d="M3 20h18" />
          <path d="M6 20v-3M9 20v-3M15 20v-3M18 20v-3" />
        </symbol>

        <symbol id="i-espace-repas-exterieur" viewBox="0 0 24 24" {...common}>
          <path d="M7 10h10" />
          <path d="M9 10v8M15 10v8" />
          <path d="M6 18h12" />
          <path d="M18 9c1-2 3-2 3-4" />
          <path d="M17 6c2 0 3-1 4-3" />
        </symbol>

        <symbol id="i-tonnelle" viewBox="0 0 24 24" {...common}>
          <path d="M5 8h14" />
          <path d="M7 8V20M17 8V20" />
          <path d="M6 12h12" />
          <path d="M4 20h16" />
        </symbol>

        <symbol id="i-plancha" viewBox="0 0 24 24" {...common}>
          <rect x="5" y="11" width="14" height="7" rx="2" />
          <path d="M8 11c0-2 1-3 1-5M12 11c0-2 1-3 1-5M16 11c0-2 1-3 1-5" />
          <path d="M8 20h8" />
        </symbol>

        <symbol id="i-brazero-barbecue" viewBox="0 0 24 24" {...common}>
          <path d="M6 10h12" />
          <path d="M7 10l1 10h8l1-10" />
          <path d="M10 6c1 1 0 2-1 3 2 0 3-1 3-2 0-1-.7-1.6-2-3Z" />
          <path d="M14 6c1 1 0 2-1 3 2 0 3-1 3-2 0-1-.7-1.6-2-3Z" />
        </symbol>

        <symbol id="i-ustensiles-barbecue" viewBox="0 0 24 24" {...common}>
          <path d="M7 4l4 4-6 6-2-2 6-6Z" />
          <path d="M11 8l9 9" />
          <path d="M14 4v6M16 4v6M18 4v6" />
          <path d="M16 10v10" />
        </symbol>

        {/* ========== Sécurité & services ========== */}
        <symbol id="i-alarme-piscine" viewBox="0 0 24 24" {...common}>
          <path d="M12 4c3 0 5 2 5 5v3l2 2H5l2-2V9c0-3 2-5 5-5Z" />
          <path d="M10 18c0 1 1 2 2 2s2-1 2-2" />
          <path d="M4 20c2-2 4-2 6 0s4 2 6 0 4-2 6 0" />
        </symbol>

        <symbol id="i-detecteur-fumee" viewBox="0 0 24 24" {...common}>
          <rect x="7" y="6" width="10" height="6" rx="2" />
          <path d="M9 16c0-1 1-2 2-2s2-1 2-2" />
          <path d="M14 18c0-1 1-2 2-2" />
          <path d="M6 20h12" />
        </symbol>

        <symbol id="i-parking" viewBox="0 0 24 24" {...common}>
          <rect x="6" y="4" width="12" height="16" rx="2" />
          <path d="M10 18V7h3a3 3 0 0 1 0 6h-3" />
        </symbol>

        <symbol id="i-lit-chaise-haute-bebe" viewBox="0 0 24 24" {...common}>
          <path d="M10 7c0-1.5 1.2-3 3-3 1.3 0 2.2.6 2.7 1.4" />
          <circle cx="13" cy="9" r="3" />
          <path d="M7 14h10" />
          <path d="M9 14v7M15 14v7" />
          <path d="M8 21h8" />
        </symbol>

        {/* ========== Manquants cuisine / éléments listés ========== */}
        <symbol id="i-ustensiles-cuisine-2" viewBox="0 0 24 24" {...common}>
          <path d="M7 4v16" />
          <path d="M7 9h3" />
          <path d="M16 4v6a3 3 0 0 1-3 3v7" />
          <path d="M12 4h6" />
        </symbol>
      </defs>
    </svg>
  );
}
